import React from "react";
import { Home } from "lucide-react";
import { Separator } from "@/components/ui/separator";
export default function AboutSimpleLiving() {
  return <section id="about-simple-living" className="relative w-full bg-[#FBFBFD] dark:bg-background text-foreground overflow-hidden flex flex-col justify-center min-h-[80vh]">
      {}
      <div className="absolute inset-0 z-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/minimalist_living_room_sun_drenched.png')] bg-cover bg-center bg-fixed opacity-[0.03] dark:opacity-[0.05] pointer-events-none" aria-hidden="true" />

      {}
      <Home className="absolute -bottom-24 -right-24 w-[500px] h-[500px] text-foreground opacity-[0.02] pointer-events-none" strokeWidth={1} aria-hidden="true" />

      <div className="relative z-10 container mx-auto px-6 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="max-w-2xl">
            <h1 className="font-default text-5xl md:text-7xl lg:text-[80px] font-medium leading-[1.1] tracking-tight text-foreground">
              Simple Living,<br />
              Automated.
            </h1>
          </div>

          {}
          <div className="max-w-xl lg:ml-auto">
            <div className="space-y-6 text-[17px] leading-[1.6] text-foreground/80 font-default">
              <p>
                We believe that a smart home shouldn't feel like a server room. By focusing exclusively on the Apple HomeKit ecosystem, we create automated spaces that are as intuitive as they are beautiful.
              </p>
              <p>
                No fragmented apps, no complex third-party hubs—just seamless, secure control built right into the devices you already use every day. We design systems that fade into the background, allowing you to focus on what truly matters.
              </p>
              <p className="font-medium text-foreground pt-4">
                Welcome to digital zen.
              </p>
            </div>
          </div>

        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full">
        <Separator className="bg-foreground h-[1px]" />
      </div>
    </section>;
}